import { makeStyles } from '@material-ui/styles';
import { Paper } from '@material-ui/core';
import React, { useState, useEffect, useContext } from 'react';
import { Table, TableHead, TableBody, TableCell, TableRow, IconButton } from '@material-ui/core';
import { Edit as EditIcon, Delete as DeleteIcon } from '@material-ui/icons';
import { i18n } from '../../translate/i18n';

import api from '../../services/api';
import { toast } from 'react-toastify';
import { AuthContext } from '../../context/Auth/AuthContext';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
    },
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    table: {
        width: '100%',
    },
    button: {
        color: 'red',
    },
}));

const fetchFail2banList = async () => {
    const { data } = await api.get('/fail2ban_list');
    return data;
};

const Fail2ban = () => {
    const classes = useStyles();
    const [ip_lista, setIpLista] = useState([]);
    const { user, socket } = useContext(AuthContext);

    useEffect(() => {
        (async () => {
            try {
                const ips = await fetchFail2banList();
                setIpLista(ips);
            } catch (err) {
                console.error(err);
            }
        })();
    }, []);

    useEffect(() => {
        if (!socket || !user?.companyId) return;
        const onFail2banUpdate = async () => {
            try {
                const ips = await fetchFail2banList();
                setIpLista(ips);
            } catch (err) {
                console.error(err);
            }
        };
        const event = `company-${user.companyId}-fail2ban`;
        socket.on(event, onFail2banUpdate);
        return () => socket.off(event, onFail2banUpdate);
    }, [socket, user?.companyId]);


    const handleDelete = async (id, ips) => {
        console.log('handleDelete chamado para id:', id);
        // Aqui você pode adicionar a lógica para deletar o IP
        await api.delete(`/fail2ban/${id}`, { data: { ips: ips } }).then(() => {
            setIpLista(ip_lista.filter((ip) => ip.id !== id));
            toast.success('IP deletado com sucesso');
        }).catch((err) => {
            console.error(err);
            toast.error('Erro ao deletar IP');
        });
    };



    return (
        <Paper className={classes.paper}>
            <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center" style={{ width: '1%' }}>#</TableCell>
                        <TableCell align="left">Id</TableCell>
                        <TableCell align="left">{i18n.t("helps.settings.description")}</TableCell>
                        <TableCell align="left">Ips</TableCell>
                        <TableCell align="left">Timezone</TableCell>
                        <TableCell align="left">Pais</TableCell>
                        <TableCell align="right" style={{ paddingRight: '3%' }}>Ações</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {ip_lista.map((row, index) => (
                        <TableRow key={row.id}>
                            <TableCell align="center" style={{ width: '1%' }}></TableCell>
                            <TableCell align="left">{index + 1 || '-'}</TableCell>
                            <TableCell align="left">{row.description || '-'}</TableCell>
                            <TableCell align="left">{row.ips || '-'}</TableCell>
                            <TableCell align="left">{row.timezone || '-'}</TableCell>
                            <TableCell align="left"><img src={row.logo} alt="Logo" style={{ width: '30px', height: '18px' }} /></TableCell>
                            <TableCell align="right">
                                <IconButton aria-label="excluir">
                                    <DeleteIcon className={classes.button} onClick={() => handleDelete(row.id, row.ips)} />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Paper>
    );
};

export default Fail2ban;